import {TranslateService} from '@ngx-translate/core';

export const enum MoodsAlertPriority {
  SadAlert = 'sad_continuity',
  TiredAlert = 'tired_continuity',
  AngryAlert = 'angry_continuity',
  HappyAlert = 'happy_continuity',
  WorriedAlert = 'worried_continuity',
  RelaxedAlert = 'relaxed_continuity',
}

export const enum SideEffectsAlertPriority {
  SadAlert = 'pain_continuity',
  NauseaVomittingAlert = 'nausea_vomitting_continuity',
  ConstipationAlert = 'constipation_continuity',
  DiarrheaAlert = 'diarrhea_continuity',
  DryMouthAlert = 'dry_mouth_continuity',
  FatigueAlert = 'fatigue_continuity',
  DifficultyBreathingAlert = 'difficulty_breathing_continuity',
  CoughAlert = 'cough_continuity',
  TroubleUrinatingAlert = 'trouble_urinating_continuity',
  FeverAlert = 'fever_continuity',
  SkinLesionsAlert = 'skin_lesions_continuity',
}

export const enum SideEffectAlertKeys {
  Pain = 'pain_alert',
  NauseaVomittingAlert = 'nausea_vomitting_alert',
  ConstipationAlert = 'constipation_alert',
  DiarrheaAlert = 'diarrhea_alert',
  DryMouthAlert = 'dry_mouth_alert',
  Tiredness = 'fatigue_alert',
  DifficultyBreathingAlert = 'difficulty_breathing_alert',
  CoughAlert = 'cough_alert',
  TroubleUrinatingAlert = 'trouble_urinating_alert',
  FeverAlert = 'fever_alert',
  SkinLesionsAlert = 'skin_lesions_alert',
}


export const enum AlertStatus {
  Active = 'Active',
  Resolved = 'Resolved',
  All = 'All',
}

export const alertLogStatusMap = (translate: TranslateService) => {
  return {
    INSERT: 'INSERT',
    UPDATE: 'UPDATE',
    AlertCreated: translate.instant('alertCreatedLbl'),
    AlertResolved: translate.instant('alertResolvedByLbl'),
    AsigneeUpdated: translate.instant('assigneeUpdatedLbl'),
  };
};
export const AlertStatusMap = (translate: TranslateService) => {
  return {
      [AlertStatus.All]: {
          value: AlertStatus.All,
          name: translate.instant('All'),
      },
      [AlertStatus.Active]: {
          value: AlertStatus.Active,
          name: translate.instant('activeLbl'),
      },
      [AlertStatus.Resolved]: {
          value: AlertStatus.Resolved,
          name: translate.instant('resolvedLbl'),
      },
  }
};